<template>
  <oxd-layout v-bind="$attrs">
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
    <template #user-actions>
      <li>
        <a
          href="#"
          role="menuitem"
          class="oxd-userdropdown-link"
          @click.prevent="toggleViewMode"
        >
          {{
            isFrontendMode
              ? 'Buka Tampilan Desktop (Admin)'
              : 'Buka Tampilan Mobile'
          }}
        </a>
      </li>
      <li>
        <a
          href="#"
          role="menuitem"
          class="oxd-userdropdown-link"
          @click="openAboutModel"
        >
          {{ $t('general.about') }}
        </a>
      </li>
      <li>
        <a :href="supportUrl" role="menuitem" class="oxd-userdropdown-link">
          {{ $t('general.support') }}
        </a>
      </li>
      <li v-if="updatePasswordUrl">
        <a
          :href="updatePasswordUrl"
          role="menuitem"
          class="oxd-userdropdown-link"
        >
          {{ $t('general.change_password') }}
        </a>
      </li>
      <li>
        <a :href="logoutUrl" role="menuitem" class="oxd-userdropdown-link">
          {{ $t('general.logout') }}
        </a>
      </li>
    </template>
    <template #nav-actions>
      <oxd-icon-button
        name="question-lg"
        :title="$t('general.help')"
        @click="onClickSupport"
      />
    </template>
  </oxd-layout>
  <about v-if="showAboutModel" @close="closeAboutModel"></about>
</template>

<script>
import {provide, readonly, ref, computed} from 'vue';
import About from '@/core/pages/About.vue';
import {OxdLayout} from '@ohrm/oxd';
import {dateFormatKey} from '@/core/util/composable/useDateFormat';

export default {
  components: {
    about: About,
    'oxd-layout': OxdLayout,
  },
  inheritAttrs: false,
  props: {
    permissions: {
      type: Object,
      default: () => ({}),
    },
    logoutUrl: {
      type: String,
      default: '#',
    },
    supportUrl: {
      type: String,
      default: '#',
    },
    updatePasswordUrl: {
      type: String,
      default: '#',
    },
    dateFormat: {
      type: Object,
      default: null,
    },
    helpUrl: {
      type: String,
      default: null,
    },
    showUpgrade: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const showAboutModel = ref(false);
    provide('permissions', readonly(props.permissions));
    provide(dateFormatKey, readonly(props.dateFormat));

    const openAboutModel = () => {
      showAboutModel.value = true;
    };

    const closeAboutModel = () => {
      showAboutModel.value = false;
    };

    const onClickSupport = () => {
      if (props.helpUrl) window.open(props.helpUrl, '_blank');
    };

    // Frontend vs Backend View Mode Toggle
    let initialMode = localStorage.getItem('vaniahr_view_mode');
    if (!initialMode) {
      initialMode = window.innerWidth > 768 ? 'backend' : 'frontend';
    }
    const viewMode = ref(initialMode);
    const isFrontendMode = computed(() => viewMode.value === 'frontend');

    // Apply body class for frontend mode to hide layout elements
    if (isFrontendMode.value) {
      document.body.classList.add('vaniahr-frontend-mode');
    }

    const toggleViewMode = () => {
      const newMode = isFrontendMode.value ? 'backend' : 'frontend';
      localStorage.setItem('vaniahr_view_mode', newMode);
      viewMode.value = newMode;
      window.location.reload(); // Reload to fully clear state and layout
    };

    return {
      onClickSupport,
      showAboutModel,
      openAboutModel,
      closeAboutModel,
      toggleViewMode,
      isFrontendMode,
    };
  },
};
</script>

<style lang="scss">
body.vaniahr-frontend-mode {
  background-color: #f5f6f8 !important;

  .oxd-layout-navigation {
    display: none !important;
    width: 0 !important;
  }
  .oxd-sidepanel {
    display: none !important;
  }
  .oxd-topbar {
    display: none !important;
  }
  .oxd-layout-context {
    padding: 0 !important;
    margin: 0 !important;
  }
  .oxd-layout-container {
    padding-left: 0 !important;
    margin-left: 0 !important;
    width: 100% !important;
  }
}

.orangehrm-upgrade-layout {
  .oxd-topbar-header-userarea {
    align-self: center;
    margin-left: unset;
  }
}
</style>
